// extracted by mini-css-extract-plugin
export var fullWidthButton = "_sa-0";